/**
 * ============================================================
 * logger.ts — Logger Exclusivo para Desenvolvimento
 * ============================================================
 *
 * Responsabilidade: Fornecer funcoes de log que so operam em
 *   builds de desenvolvimento. Em producao, todas as chamadas
 *   sao no-ops (nao imprimem nada no console).
 *
 * Quando usar: Em vez de console.error/warn/info/debug direto,
 *   use logger.error(...) para garantir que logs nao vazem
 *   para producao.
 *
 * @example
 *   logger.error('Falha ao salvar deal', { id, error });
 * ============================================================
 */
const isDev = import.meta.env.DEV;

export const logger = {
  error: (...args: unknown[]) => { if (isDev) console.error(...args); },
  warn: (...args: unknown[]) => { if (isDev) console.warn(...args); },
  info: (...args: unknown[]) => { if (isDev) console.info(...args); },
  debug: (...args: unknown[]) => { if (isDev) console.debug(...args); },
};
